// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const decidueye_hisui: PokeData = {
  "id": 10244,
  "name": "decidueye-hisui",
  "height": 16,
  "weight": 370,
  "base_experience": 239,
  "types": [
    PokeType.GRASS,
    PokeType.FIGHTING
  ],
  "api_moves": [
    "gust",
    "tackle",
    "growl",
    "peck",
    "razor-leaf",
    "synthesis",
    "rock-smash",
    "feather-dance",
    "aerial-ace",
    "bulk-up",
    "magical-leaf",
    "leaf-blade",
    "roost",
    "pluck",
    "u-turn",
    "sucker-punch",
    "aura-sphere",
    "air-slash",
    "brave-bird",
    "shadow-sneak",
    "leaf-storm",
    "leafage",
    "triple-arrows"
  ],
  "moves": [
    "gust",
    "tackle",
    "growl",
    "peck",
    "razor-leaf",
    "synthesis",
    "rock-smash",
    "aerial-ace",
    "bulk-up",
    "roost",
    "air-slash",
    "brave-bird",
    "shadow-sneak"
  ],
  "evolution_chain": {
    "id": 374,
    "item": null,
    "species": [
      {
        "name": "rowlet",
        "order": 722,
        "types": [
          PokeType.GRASS,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "dartrix",
        "order": 723,
        "types": [
          PokeType.GRASS,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 722,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 17,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "decidueye",
        "order": 724,
        "types": [
          PokeType.GRASS,
          PokeType.GHOST
        ],
        "evolves_from_species_id": 723,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 34,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 135,
    "speed": 92,
    "ability_power": 172
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": "hisui"
} as const;
